<div class="floorplan-container" fxLayout="column">
  <ng-container *ngIf=" !viewDetail">
    <!-- <div class="flex justify-end">
      <button mat-button class="add-button" (click)="openEditFloorPlanDialog(false)">
          <mat-icon style="margin-bottom: 2px; width: 16px; height: 16px; font-size: 16px; margin-right: 4px">
              add
          </mat-icon>
          Add floorplan
      </button>
    </div> -->
    <div class="flex justify-between align-center">
      <div class="floorplan-title">
        Total {{project.floorPlans.length}} Floorplans
      </div>
      <div class="flex align-center">
        <!-- <mat-select [(value)]="selected" class="sort-select">
          <mat-option *ngFor="let selectUnit of selectList" [value]="selectUnit">
            {{ selectUnit }}
          </mat-option>
        </mat-select> -->
        <input (keyup.enter)="filterData()" [(ngModel)]="keywords" class="input search-input" type="text"
          placeholder="Search Floorplan Name" />
        <input (keyup.enter)="filterData()" style="width:180px" [(ngModel)]="filterBedRoom" class="input search-input"
          type="number" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" min="0"
          placeholder="Search Bedroom Number" />
        <input (keyup.enter)="filterData()" style="width:180px" [(ngModel)]="filterBathRoom" class="input search-input"
          type="number" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" min="0"
          placeholder="Search Bathroom Number" />
        <!-- <div class="switch-button-group" fxLayout="row" fxLayoutAlign="center center">
          <button mat-button [ngClass]="{'active':  layout == 'grid'}" class="switch-button" (click)="layout='grid'"
            fxLayout="row" fxLayoutAlign="center center">
            <mat-icon style="width:22px;height:22px;font-size:22px" fontSet="material-icons-round">grid_view
            </mat-icon>
          </button>
          <button mat-button [ngClass]="{'active': layout == 'list'}" class="switch-button" (click)="layout='list'"
            fxLayout="row" fxLayoutAlign="center center">
            <mat-icon style="width:22px;height:22px;font-size:22px">format_list_bulleted</mat-icon>
          </button>
        </div> -->
      </div>
    </div>
    <!-- <div fxLayout="row" fxLayoutAlign="space-between center">
      <div class="floorplan-title">
        Total {{project.floorPlans.length}} Floorplan
      </div>
      <div fxLayout="row" fxLayoutGap="12px">
        <input (keyup.enter)="filterData()" [(ngModel)]="keywords" class="input search-input" type="text" placeholder="Search Floorplan Name" />
        <input (keyup.enter)="filterData()" style="width:180px" [(ngModel)]="filterBedRoom" class="input search-input" type="number" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" placeholder="Search BedRoom Number" />
        <input (keyup.enter)="filterData()" style="width:180px" [(ngModel)]="filterBathRoom" class="input search-input" type="number" onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" placeholder="Search BathRoom Number" />

        <button mat-button class="add-floorplan-button" (click)="openEditFloorPlanDialog(false)">
          <mat-icon style="margin-bottom: 2px; width: 16px; height: 16px; font-size: 16px; margin-right: 4px">
            add
          </mat-icon>
          Add floorplan
        </button>
      </div>
    </div> -->

    <div *ngIf="floorPlans && floorPlans.length > 0" style="margin-top:23px;width: 100%;">
      <mat-grid-list [cols]="gridCol" rowHeight="278px" gutterSize="20" style="width: 100%">
        <mat-grid-tile *ngFor="let floorPlan of floorPlans" [colspan]="1" [rowspan]="1">
          <div class="floorplan-box" (click)="viewFloorPlan(floorPlan)">
            <div fxLayout="row" fxLayoutAlign="center center" style="position:relative;height:194px;">
              <img *ngIf="floorPlan.images && floorPlan.images.length" [src]="getImageUrl(floorPlan.images[0].fileName)"
                style="object-fit: contain;width: 100%;height: 194px;" />
              <img *ngIf="!floorPlan.images" src="./assets/images/black/floorplan.png"
                style="object-fit: contain;width: 100%;height: 194px;" />
            </div>
            <div class="floorplan-name" fxLayoutAlign="flex-start center">
              <div style="text-align:left;overflow: hidden;text-overflow: ellipsis;white-space:nowrap;width: 150px;">
                {{floorPlan.notes}}</div>
              <div style="font-size:14px;color: rgba(222, 222, 222, 0.4);">
                {{floorPlan.bedRoom || 0}} B / {{floorPlan.bathRoom || 0}} B
              </div>
            </div>
            <div style="height: 30px;margin-top: 20px;">
              <div *ngIf="floorPlan.urls" fxLayout="row" fxLayoutAlign="center center" class="ar-tag"><img
                  src="./assets/images/ar-icon.png">AR</div>
            </div>

          </div>
        </mat-grid-tile>
      </mat-grid-list>
    </div>
    <div fxFlexAlign="center" fxFlex="100">
      <ng-container *ngIf="!floorPlans || floorPlans.length === 0">
        <div
          style="display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 40px 0;height: 600px;">
          <p style="margin:4px;color: #DEDEDE;font-size: 18px;font-weight: 600;">No floorplan found</p>
          <p style="margin:4px;color: #DEDEDE;opacity: 0.7;">You have not added any floorplan in this building</p>
          <button (click)="openEditFloorPlanDialog(false)" mat-flat-button
            style="margin-top:12px;background: #000;border-radius: 4px;color:#DEDEDE;border: 1px solid #DEDEDE;">Add
            floorplan</button>
        </div>
      </ng-container>
    </div>

  </ng-container>


  <div *ngIf="viewDetail">
    <div class="floorplan-detail" fxLayout="column">
      <div fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="back" (click)="closeFloorPlan()">navigate_before</mat-icon>
        <div style="font-size: 14px;font-weight: 500;color: #DEDEDE;">Floorplans</div>
      </div>

      <div class="floorplan-title">
        <div>{{floorPlan.notes}}</div>
        <div class="floorplan-building">{{floorPlan.bedRoom}} Bedroom / {{floorPlan.bathRoom}} Bathroom</div>
      </div>


      <div fxLayout="row wrap" fxLayoutGap.gt-md="1%">
        <div class="floorplan-images" fxFlex="29" fxFlex.lt-md="100">
          <div fxLayout="row" fxLayoutAlign="space-between">
            <div class="floorplan-table-title">Floorplan</div>
            <mat-icon [matMenuTriggerFor]="operateMenu" style="cursor: pointer;">more_vert</mat-icon>
          </div>
          <mat-menu #operateMenu="matMenu" xPosition="before" class="operate_box">
            <button mat-menu-item (click)="openEditFloorPlanDialog(true)">Edit floorplan details</button>
            <button mat-menu-item (click)="openConnectPropertyDialog()">Edit connected properties</button>
            <button mat-menu-item (click)="openDeleteConfirmDialog()">Delete floorplan</button>
          </mat-menu>
          <div class="swiper-container">
            <swiper *ngIf="floorPlan.images && floorPlan.images.length" [navigation]="true"
              [pagination]="{type: 'bullets', clickable: true}" [navigation]="true"
              [slideActiveClass]="'active-bullet'">
              <ng-template swiperSlide *ngFor="let image of floorPlan.images">
                <div style="width: 100%; height: auto; background: #ffffff">
                  <img (click)="openImagePreviewDialog()" [src]="getImageUrl(image.fileName)"
                    style="width: 100%; height: 443px; object-fit: contain">
                </div>
              </ng-template>
            </swiper>
          </div>
          <div style="font-size:18px;font-weight:600;margin-bottom:8px;margin-top:24px">AR Model</div>
          <ng-container *ngIf="floorPlan.urls">
            <div class="ar-item" fxLayout="row" fxLayoutAlign="space-between center"
              *ngIf="floorPlan.urls && floorPlan.urls.ios">
              <div class="ar-item-title">IOS</div>
              <div class="ar-item-file" (click)="openArPreviewDialog(false)"><img style="height:14px;margin-right:8px"
                  src="./assets/images/clip-icon.png">{{floorPlan.urls.ios}}</div>
            </div>
            <div class="ar-item" fxLayout="row" fxLayoutAlign="space-between"
              *ngIf="floorPlan.urls && floorPlan.urls.android">
              <div class="ar-item-title">Android</div>
              <div class="ar-item-file" (click)="openArPreviewDialog(true)"><img style="height:14px;margin-right:8px"
                  src="./assets/images/clip-icon.png">{{floorPlan.urls.android}}
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!floorPlan.urls">
            <div class="ar-item" fxLayout="row" fxLayoutAlign="space-between center">
              <div class="ar-item-title">No AR Model uploaded.</div>
              <div class="ar-item-file"
                style="color: #2142FF;font-weight: 400;cursor: pointer;text-decoration-line: underline;"
                (click)="openEditFloorPlanDialog(true, 2)">Upload AR model</div>
            </div>
          </ng-container>

        </div>
        <div class="floorplan-table" fxFlex="70" fxFlex.lt-md="100" *ngIf="floorPlanProperties.length">
          <div fxLayoutAlign="space-between center">
            <div style="font-weight: 600;font-size: 18px;">Connected Properties</div>
            <button mat-button class="floorplan-button" (click)="openConnectPropertyDialog()">Edit</button>
          </div>
          <table mat-table [dataSource]="floorPlanProperties" style="width: 100%;">
            <ng-container matColumnDef="unit">
              <th mat-header-cell *matHeaderCellDef>
                <div class="properties-table-title">Unit Number</div>
              </th>
              <td mat-cell *matCellDef="let element">
                {{element.unitNum}}
              </td>
            </ng-container>
            <ng-container matColumnDef="config">
              <th mat-header-cell *matHeaderCellDef>
                <div class="properties-table-title">Bed / Bath / Car park</div>
              </th>
              <td mat-cell *matCellDef="let element">
                {{element.bedRoom}}/{{element.bathRoom}}/{{element.carParking}}
              </td>
            </ng-container>

            <ng-container matColumnDef="building">
              <th mat-header-cell *matHeaderCellDef>
                <div class="properties-table-title">Building name</div>
              </th>
              <td mat-cell *matCellDef="let element">
                <span style="cursor: pointer">{{element.project.name}}</span>
              </td>
            </ng-container>
            <ng-container matColumnDef="price">
              <th mat-header-cell *matHeaderCellDef>
                <div class="properties-table-title">Price (AUD)</div>
              </th>
              <td mat-cell *matCellDef="let element">
                <span style="cursor: pointer">{{element.price | currency: '':'symbol':'1.0-0'}}</span>
              </td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>
                <div class="properties-table-title">Status</div>
              </th>
              <td mat-cell *matCellDef="let element" style="text-align: left;">
                <span style="cursor: pointer" style="padding-left: 20px;">
                  <ng-container *ngIf="element.status === 0">
                    <label style="margin-right: 8px;color: #B0DDCD">● Unavailable</label>
                  </ng-container>
                  <ng-container *ngIf="element.status === 1">
                    <label style="margin-right: 8px;color: #74FF17">● Available</label>
                  </ng-container>
                  <ng-container *ngIf="element.status === 2 || element.status === 3">
                    <label style="margin-right: 8px;color: #FD4954">● Reserved</label>
                  </ng-container>
                  <ng-container *ngIf="element.status === 4 || element.status ===5">
                    <label style="margin-right: 8px;color: #FFAA21">● Processing</label>
                  </ng-container>
                  <ng-container *ngIf="element.status === 6">
                    <label style="margin-right: 8px;color: #B0B0B0">● Settle</label>
                  </ng-container>
                </span>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
        <div class="floorplan-table" fxFlex="70" fxFlex.lt-md="100" *ngIf="!floorPlanProperties.length"
          fxLayoutAlign="center center">
          <div
            style="display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 40px 0;">
            <p style="margin:4px;color: #DEDEDE;font-size: 18px;font-weight: 600;">No property found :(</p>
            <p style="margin:4px;color: rgba(222, 222, 222, 0.4);opacity: 0.7;">You have not added any property in this
              building</p>
            <button (click)="openConnectPropertyDialog()" mat-flat-button
              style="margin-top:48px;background: #000;border-radius: 8px;color:rgba(222, 222, 222, 0.6);width: 267px;height: 52px;border: 1px solid rgba(222, 222, 222, 0.6);">Connect
              Property</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>